export default {
  // القائمة الرئيسية
  menu: {
    dashboard: "لوحة التحكم",
    liveOps: "العمليات المباشرة",
    bookings: "الحجوزات",
    realRides: "الرحلات الحقيقية",
    routes: "الطرق",
    captains: "الكباتن",
    buses: "الحافلات",
    users: "المستخدمين",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    more: "المزيد",
    search: "البحث",
    allPages: "جميع الصفحات",
    searchPages: "البحث في الصفحات...",
    companiesWithRoutes: "الشركات المسجلة عبر الموقع",
  },

  // أزرار عامة
  buttons: {
    save: "حفظ",
    cancel: "إلغاء",
    edit: "تعديل",
    delete: "حذف",
    add: "إضافة",
    search: "بحث",
    close: "إغلاق",
    back: "رجوع",
    next: "التالي",
    previous: "السابق",
    view: "عرض",
    details: "التفاصيل",
    tripDetails: "تفاصيل الرحلة",
    viewRoute: "عرض الطريق",
    confirm: "تأكيد",
    clear: "مسح",
    searchInResults: "البحث في النتائج",
    searchInResultsPlaceholder: "البحث في النتائج...",
    resetPassword: "إعادة تعيين كلمة المرور",
    upload: "رفع",
    addNew: "إضافة جديد",
  },

  // الجداول
  table: {
    noData: "لا توجد بيانات",
    loading: "جاري التحميل...",
    showing: "عرض",
    to: "إلى",
    of: "من",
    entries: "سجل",
    rowsPerPage: "صفوف في الصفحة",
    first: "الأول",
    last: "الأخير",
    previous: "السابق",
    next: "التالي",
    search: "البحث",
    searchByName: "البحث بالاسم",
    searchByFromArea: "البحث بمنطقة البداية",
    searchByToArea: "البحث بمنطقة النهاية",
    searchByBaseFair: "البحث بالسعر",
    searchById: "البحث بالرقم التعريفي",
    id: "الرقم التعريفي",
    icon: "الأيقونة",
    actions: "الإجراءات",
  },

  // الحالة
  status: {
    active: "نشط",
    inactive: "غير نشط",
    pending: "في الانتظار",
    completed: "مكتمل",
    cancelled: "ملغي",
    running: "قيد التشغيل",
    stopped: "متوقف",
  },

  companyStatus: {
    new: "جديد",
    underReview: "مراجعة",
    approved: "مقبول",
    rejected: "مرفوض",
  },

  // الرسائل
  messages: {
    confirm: "تأكيد",
    confirmDelete: "هل أنت متأكد من الحذف؟",
    saveSuccess: "تم الحفظ بنجاح",
    deleteSuccess: "تم الحذف بنجاح",
    errorOccurred: "حدث خطأ",
    noResults: "لا توجد نتائج",
    enterAllData: "الرجاء إدخال جميع البيانات أولاً",
    invalidData: "بيانات غير صالحة",
    done: "تم",
    invalid: "غير صالح",
    deleted: "تم الحذف",
    error: "خطأ",
    added: "تمت الإضافة",
    edited: "تم التعديل",
    deleted: "تم الحذف",
    success: "نجاح",
    warning: "تحذير",
  },

  // مشتركة
  common: {
    coordinates: "الإحداثيات",
    email: "البريد الإلكتروني",
    admin: "مسؤول",
  },

  dialogs: {
    deleteConfirm: "تأكيد الحذف",
    resetPasswordConfirm: "تأكيد إعادة تعيين كلمة المرور",
  },

  corporates: {
    manageEmails: "إدارة الإيميلات",
    enterEmail: "برجاء إدخال البريد الإلكتروني",
    addEmailFailed: "فشل في إضافة البريد.",
    deleteEmailConfirm: "هل أنت متأكد من حذف هذا البريد ({email})؟",
    deleteEmailFailed: "فشل في حذف البريد.",
    resetPasswordConfirm: "هل أنت متأكد من إعادة تعيين كلمة المرور للبريد ({email})؟",
    resetPasswordFailed: "فشل في إعادة تعيين كلمة المرور.",
    addTitle: "إضافة شركة",
    editTitle: "تعديل شركة",
    name: "اسم الشركة",
    address: "العنوان",
    phones: "الهواتف",
    enterPhone: "أدخل رقم الهاتف",
    addPhone: "إضافة هاتف",
    uploadLogo: "رفع الشعار",
    addCorporate: "إضافة شركة",
    saveChanges: "حفظ التغييرات",
    title: "الشركات",
    accounts: "الحسابات",
    showAllPhones: "عرض كل الهواتف",
    noCorporates: "لا توجد شركات بعد.",
    searchByAddress: "البحث بالعنوان",
  },

  // الترجمة
  language: {
    arabic: "العربية",
    english: "English",
    switchLanguage: "تغيير اللغة",
  },

  companies: {
    title: "الشركات المسجلة عبر الموقع",
    name: "الاسم",
    phone: "الهاتف",
    email: "البريد",
    address: "العنوان",
    createdAt: "تاريخ الإنشاء",
    routes: "الخطوط",
    commercialRegistry: "السجل التجاري",
    taxCard: "البطاقة الضريبية",
    logo: "الشعار",
    from: "من",
    to: "إلى",
    numberOfLines: "عدد الخطوط",
    changeStatus: "تغيير الحالة",
    notes: "ملاحظات",
    selectStatus: "اختر الحالة",
    updateStatusSuccess: "تم تحديث الحالة بنجاح",
    updateStatusError: "حدث خطأ أثناء تحديث الحالة",
  },

  // المستخدمين
  users: {
    title: "المستخدمين",
    searchByPhoneNumber: "البحث برقم الهاتف",
    id: "الرقم التعريفي",
    name: "الاسم",
    phone: "الهاتف",
    email: "البريد الإلكتروني",
    status: "الحالة",
    actions: "الإجراءات",
    noUsersYet: "لا يوجد مستخدمين بعد",
    userDetails: "تفاصيل المستخدم",
  },

  // عدد الحجوزات
  bookingCount: {
    title: "عدد الحجوزات",
    rideDate: "تاريخ الرحلة",
    booking: "الحجز",
    noUsers: "لا يوجد مستخدمين بعد",
    errorInGetData: "خطأ في جلب البيانات",
  },

  // رصيد الترحيب
  welcomeBalance: {
    title: "رصيد الترحيب للمستخدمين",
    customer: "العميل",
    mobile: "الموبايل",
    balance: "رصيد الترحيب",
    hasWelcome: "له رصيد ترحيبي",
    lastTransactionDate: "آخر عملية ترحيب",
    addDialogTitle: "إضافة رصيد ترحيب",
    amount: "المبلغ",
    note: "ملاحظة",
    actions: "إجراءات",
    addEditBalance: "إضافة / تعديل رصيد الترحيب",
    showUserTransactions: "عرض عمليات المستخدم",
    userTransactionsTitle: "عمليات المستخدم {name}",
  },

  corporateCancellationPercentage: {
    title: "سياسة إلغاء الشركات",
    corporate: "الشركة",
    minHoursBeforeRide: "الحد الأدنى للساعات قبل الرحلة",
    deductionPercentage: "نسبة الخصم",
    actions: "الإجراءات",
    addDialogTitle: "إضافة سياسة إلغاء للشركة",
    addEditPolicy: "إضافة / تعديل السياسة",
    deleteConfirm: "هل أنت متأكد من حذف هذه السياسة؟",
    showPolicies: "عرض سياسات الإلغاء",
    policyCount: "عدد السياسات",
  },

  // نسب الشركات
  corporatePercentage: {
    title: "نسب الشركات",
    corporate: "الشركة",
    mobile: "الموبايل",
    balance: "الرصيد",
    regoPercentage: "نسبة REGO",
    userPercentage: "نسبة المستخدم",
    fromDate: "من تاريخ",
    toDate: "إلى تاريخ",
    actions: "إجراءات",
    addDialogTitle: "إضافة نسبة للشركة",
    amount: "المبلغ",
    note: "ملاحظة",
    addEditPercentage: "إضافة / تعديل النسبة",
    showHistory: "عرض السجل السابق",
    historyTitle: "سجل النسب للشركة {name}",
  },

  // صفحات النظام (لوحة الإدارة)
  pages: {
    title: "الصفحات",
    addNew: "إضافة صفحة",
    name: "الاسم (إنجليزي)",
    nameAr: "الاسم (عربي)",
    route: "المسار",
    parentPage: "الصفحة الأب",
    icon: "الأيقونة",
    noPages: "لا توجد صفحات بعد.",
    addDialogTitle: "إضافة صفحة",
    editDialogTitle: "تعديل صفحة",
    cancel: "إلغاء",
    add: "إضافة",
    edit: "تعديل",
  },

  // تفاصيل الحجز
  bookingDetails: {
    title: "تفاصيل الحجز",
    selectDate: "اختر التاريخ",
    search: "البحث",
    customer: "العميل",
    phone: "الهاتف",
    route: "الطريق",
    status: "الحالة",
    pickupStop: "محطة الاستلام",
    dropOffStop: "محطة النزول",
    rideDate: "تاريخ الرحلة",
    noBookings: "لا توجد حجوزات بعد",
    searchById: "البحث بالرقم التعريفي",
    searchByCustomer: "البحث بالعميل",
    searchByPhone: "البحث بالهاتف",
    searchByRoute: "البحث بالطريق",
    searchByStatus: "البحث بالحالة",
    searchByPickupStop: "البحث بمحطة الاستلام",
    searchByDropOffStop: "البحث بمحطة النزول",
    chooseRoute: "اختر الطريق",
    chooseStatus: "اختر الحالة",
    promoCode: "كود الخصم",
    finalPrice: "السعر النهائي",
  },

  // الحجوزات
  bookings: {
    title: "الحجوزات",
    customer: "العميل",
    phone: "الهاتف",
    bookDate: "تاريخ الحجز",
    status: "الحالة",
    route: "الطريق",
    seats: "المقاعد",
    rideDate: "تاريخ الرحلة",
    noBookings: "لا توجد حجوزات بعد",
    searchByCustomer: "البحث بالعميل",
    searchByPhone: "البحث بالهاتف",
    searchByRoute: "البحث بالطريق",
    from: "من",
    to: "إلى",
    selectCorporate: "اختر الشركة",
    pleaseSelectDates: "يرجى اختيار تاريخي 'من' و 'إلى' قبل البحث.",
    bookingCancelled: "تم إلغاء الحجز بنجاح",
    failedToCancel: "فشل في إلغاء الحجز",
    errorOccurred: "حدث خطأ أثناء إلغاء الحجز",
    cancelBookingConfirmation: "تأكيد إلغاء الحجز",
    areYouSureCancel: "هل أنت متأكد من إلغاء هذا الحجز؟",
    noKeepBooking: "لا، احتفظ بالحجز",
    yesCancelBooking: "نعم، ألغِ الحجز",
    thisActionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء.",
    bookedSeats: "المقاعد المحجوزة",
    unknownCustomer: "عميل غير معروف",
    noSeatNumbers: "لا توجد أرقام مقاعد متاحة",
    totalSeats: "إجمالي المقاعد",
    viewSeats: "عرض المقاعد",
    cancelBooking: "إلغاء الحجز",
  },

  // لوحة التحكم
  dashboard: {
    bookingSource: "مصدر الحجز",
    dailyBookingSource: "مصدر الحجز اليومي",
    monthlyRideStats: "إحصائيات الرحلات الشهرية",
    routeStatistics: "إحصائيات الطرق",
    noBookingSourceData: "لا توجد بيانات مصدر الحجز متاحة.",
    noDailyBookingStats: "لا توجد إحصائيات حجز يومية متاحة.",
    noMonthlyRideStats: "لا توجد إحصائيات رحلات شهرية متاحة.",
    noRouteStats: "لا توجد إحصائيات طرق.",
    appBookings: "حجوزات التطبيق",
    companyBookings: "حجوزات الشركة",
    executed: "منفذة",
    cancelled: "ملغية",
    notExecuted: "غير منفذة",
    routeName: "اسم الطريق",
    totalRides: "إجمالي الرحلات",
    finished: "منتهية",
    notStarted: "لم تبدأ",
    inProgress: "قيد التنفيذ",
    totalBookings: "إجمالي الحجوزات",
    cancelledBookings: "الحجوزات الملغية",
    rideDetailsFor: "تفاصيل الرحلات لـ",
    rides: "رحلات",
    noRideDetails: "لا توجد تفاصيل رحلات متاحة لهذا الطريق في الفترة المحددة.",
    loadingRideDetails: "جاري تحميل تفاصيل الرحلات...",
    rideId: "معرف الرحلة",
    captain: "الكابتن",
    busType: "نوع الحافلة",
    bookings: "الحجوزات",
    notAssigned: "غير محدد",
    currentMonthBookings: "حجوزات الشهر الحالي",
    total: "الإجمالي",
    fromUs: "مننا؟",
    yes: "نعم",
    no: "لا",
    noBookingsFound: "لا توجد حجوزات.",
    buses: "الحافلات",
    captains: "الكباتن",
    routes: "الطرق",
    rides: "الرحلات",
    details: "التفاصيل",
    plateNumber: "رقم اللوحة",
    type: "النوع",
    captainName: "اسم الكابتن",
    phone: "الهاتف",
    noBusesFound: "لا توجد حافلات.",
    noCaptainsFound: "لا يوجد كباتن.",
    noRoutesFound: "لا توجد طرق.",
    noRidesFound: "لا توجد رحلات.",
    loading: "جاري التحميل...",
    currentMonthRides: "رحلات الشهر الحالي",
    start: "البداية",
    end: "النهاية",
  },

  // نقاط التوقف
  stops: {
    title: "نقاط التوقف",
    addNew: "إضافة نقطة توقف جديدة",
    addTitle: "إضافة نقطة توقف جديدة",
    editTitle: "تعديل نقطة التوقف",
    viewTitle: "عرض نقطة التوقف",
    arabicName: "الاسم بالعربية",
    englishName: "الاسم بالإنجليزية",
    status: "الحالة",
    coordinates: "الإحداثيات",
    area: "المنطقة",
    id: "الرقم التعريفي",
    nameAr: "الاسم بالعربية",
    nameEn: "الاسم بالإنجليزية",
    clear: "مسح",
    searchById: "البحث بالرقم التعريفي",
    searchByName: "البحث بالاسم",
    searchByArea: "البحث بالمنطقة",
    noStops: "لا توجد نقاط توقف بعد",
    selectCorporate: "اختر الشركة",
    addSuccess: "تمت إضافة نقطة التوقف بنجاح",
    editSuccess: "تم تعديل نقطة التوقف بنجاح",
    deleteSuccess: "تم حذف نقطة التوقف بنجاح",
    deleteFailed: "فشل في حذف نقطة التوقف",
    enterAllData: "الرجاء إدخال جميع البيانات أولاً",
    invalidCoordinates: "إحداثيات غير صالحة",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
  },

  // محطات الرحلة الحقيقية
  realRideStops: {
    title: "محطات الرحلة",
    journeyStops: "محطات الرحلة",
    arrivalTime: "وقت الوصول",
    stationName: "اسم المحطة",
    stationStatus: "حالة المحطة",
    inBus: "في الحافلة",
    passengersPickedUp: "ركاب صعدوا",
    passengersDroppedOff: "ركاب نزلوا",
    waiting: "في الانتظار",
    skipped: "تم التخطي",
    completed: "مكتمل",
    arrived: "وصلت",
    busArrived: "وصلت الحافلة",
    busDeparted: "غادرت الحافلة",
    skipStation: "تخطي المحطة",
    confirmArrival: "هل أنت متأكد من وصول الحافلة؟",
    confirmDeparture: "هل أنت متأكد من مغادرة الحافلة؟",
    confirmSkip: "هل أنت متأكد من تخطي هذه المحطة؟",
    cannotSkipWithPassengers: "لا يمكن تخطي هذه المحطة لوجود ركاب",
    operationSuccess: "تم تنفيذ العملية بنجاح",
    operationError: "حدث خطأ",
    unexpectedError: "حدث خطأ غير متوقع",
    timeFormat: "وقت التخطي",
    actualArrivalTime: "وقت الوصول الفعلي",
    departureTime: "وقت المغادرة",
  },

  // تفاصيل الرحلة
  tripData: {
    title: "تفاصيل الرحلة",
    tripInformation: "معلومات الرحلة",
    routeName: "اسم الطريق",
    categoryName: "اسم الفئة",
    rideDate: "تاريخ الرحلة",
    rideTime: "وقت الرحلة",
    arrivalTime: "وقت الوصول",
    status: "الحالة",
    scheduled: "مجدول",
    started: "بدأت",
    ended: "انتهت",
    cancelled: "ملغية",
    captainName: "اسم الكابتن",
    busNumber: "رقم الحافلة",
    busType: "نوع الحافلة",
    booking: "الحجز",
    noData: "لا توجد بيانات",
    totalPassengers: "إجمالي الركاب",
    totalRevenue: "إجمالي الإيرادات",
    startTime: "وقت البداية",
    endTime: "وقت النهاية",
    duration: "المدة",
    distance: "المسافة",
    notAssigned: "غير محدد",
    noData: "لا توجد بيانات",
  },

  // تبويب الرحلة
  tabPopup: {
    title: "تفاصيل الرحلة",
    tripDetails: "تفاصيل الرحلة",
    tripInformation: "معلومات الرحلة",
    tripStops: "محطات الرحلة",
    captainInformation: "معلومات الكابتن",
    busInfo: "معلومات الحافلة",
    route: "الطريق",
    passengers: "الركاب",
    balance: "الرصيد",
    changeDate: "تغيير التاريخ",
    cancelTrip: "إلغاء الرحلة",
    startTrip: "بدء الرحلة",
    endTrip: "إنهاء الرحلة",
    changeCaptain: "تغيير الكابتن",
    removeCaptain: "إزالة الكابتن",
    addDeduction: "إضافة خصم",
    addBonus: "إضافة مكافأة",
    hideTrip: "إخفاء الرحلة",
    showTrip: "إظهار الرحلة",
    confirmHideTrip: "هل أنت متأكد من إخفاء الرحلة؟",
    confirmShowTrip: "هل أنت متأكد من إظهار الرحلة؟",
    tripCannotStartNow: "لا يمكن بدء الرحلة الآن",
    tripDoesNotHaveBus: "الرحلة ليس لها حافلة بعد",
    tripDoesNotHaveCaptain: "الرحلة ليس لها كابتن",
    timeDifference: "الفرق الزمني",
    operationCompleted: "تم تنفيذ العملية بنجاح",
    errorOccurred: "حدث خطأ",
    enterAllData: "الرجاء إدخال جميع البيانات أولاً",
    enterReason: "الرجاء إدخال السبب أولاً",
    startTime: "وقت البداية",
    endTime: "وقت النهاية",
    startReason: "سبب البداية",
    endReason: "سبب النهاية",
    note: "ملاحظة",
    enterNote: "أدخل الملاحظة...",
    changeBus: "تغيير الحافلة",
    addStart: "إضافة بداية",
    addEnd: "إضافة نهاية",
    editSuccess: "تم التعديل بنجاح",
    cancelled: "تم الإلغاء",
    hidden: "تم الإخفاء",
    shown: "تم الإظهار",
  },

  // الطرق
  routes: {
    title: "الطرق",
    addNew: "إضافة طريق جديد",
    addTitle: "إضافة طريق جديد",
    editTitle: "تعديل الطريق",
    name: "الاسم",
    baseFair: "السعر",
    status: "الحالة",
    test: "اختبار",
    fromGovernate: "من المحافظة",
    toGovernate: "إلى المحافظة",
    totalDistance: "المسافة الإجمالية",
    estimatedTime: "الوقت المقدر",
    noRoutes: "لا توجد طرق بعد",
    addSuccess: "تمت إضافة الطريق بنجاح",
    editSuccess: "تم تعديل الطريق بنجاح",
    deleteSuccess: "تم حذف الطريق بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    addStopPoints: "إضافة نقاط التوقف إلى",
    routeStops: "نقاط توقف الطريق",
    routePrice: "سعر الطريق",
    routePricing: "تسعير الطريق",
    available: "متاح",
    selected: "محدد",
    sortNum: "رقم الترتيب",
    distance: "المسافة",
    time: "الوقت",
    price: "السعر",
    totalDistanceToNext: "المسافة الإجمالية إلى التالي",
    totalTimeToNext: "الوقت الإجمالي إلى التالي",
    totalPrice: "السعر الإجمالي",
    noSearchResults: "لا توجد نتائج بحث بعد",
    selectGovernate: "اختر المحافظة",
    selectArea: "اختر المنطقة",
    selectStops: "اختر نقاط التوقف",
    pickup: "استلام",
    saveStops: "حفظ نقاط التوقف",
    stopPointsAdded: "تمت إضافة نقاط التوقف بنجاح",
    distanceTimeError: "لم نتمكن من الحصول على الوقت والمسافة المقدرة",
    atLeastTwoStops: "يحتاج إلى نقطتي توقف على الأقل",
    minutes: "دقائق",
    km: "كم",
    viewRoute: "عرض الطريق",
    scheduleRoute: "جدولة الطريق",
    routeStops: "نقاط توقف الطريق",
    editRoute: "تعديل الطريق",
    deleteRoute: "حذف الطريق",
    testField: "حقل الاختبار"
  },

  // الدول
  countries: {
    title: "الدول",
    addNew: "إضافة دولة جديدة",
    addTitle: "إضافة دولة جديدة",
    editTitle: "تعديل الدولة",
    name: "اسم الدولة",
    showGovernorates: "عرض المحافظات",
    addSuccess: "تمت إضافة الدولة بنجاح",
    editSuccess: "تم تعديل الدولة بنجاح",
  },

  // المناطق
  areas: {
    title: "المناطق",
    addNew: "إضافة منطقة جديدة",
    addTitle: "إضافة منطقة جديدة",
    editTitle: "تعديل المنطقة",
    country: "الدولة",
    governate: "المحافظة",
    name: "اسم المنطقة",
    addSuccess: "تمت إضافة المنطقة بنجاح",
    editSuccess: "تم تعديل المنطقة بنجاح",
  },

  // المحافظات
  governates: {
    title: "المحافظات",
    addNew: "إضافة محافظة جديدة",
    addTitle: "إضافة محافظة جديدة",
    editTitle: "تعديل المحافظة",
    country: "الدولة",
    arabicName: "الاسم بالعربية",
    englishName: "الاسم بالإنجليزية",
    addSuccess: "تمت إضافة المحافظة بنجاح",
    editSuccess: "تم تعديل المحافظة بنجاح",
  },



  // رسم الطريق
  routeDraw: {
    addLiveLocation: "إضافة الموقع المباشر للكابتن",
    trackLocation: "تتبع الموقع",
    location: "الموقع",
    trackLiveLocationMessage: "تتبع الموقع المباشر للكابتن",
    liveLocationStarted: "تم بدء تتبع الموقع المباشر بنجاح",
    userUnavailable: "المستخدم غير متاح",
    liveLocationError: "فشل في بدء تتبع الموقع المباشر",
    noLocationData: "لا توجد بيانات موقع متاحة بعد عدة محاولات",
    locationFetchError: "فشل في جلب بيانات الموقع",
    mapInitError: "فشل في تهيئة الخريطة",
    routeFetchError: "فشل في جلب بيانات الطريق",
    newMessage: "رسالة جديدة مستلمة",
    newMessageBody: "لديك رسالة جديدة",
  },

  // الجداول الزمنية
  schedule: {
    title: "الجداول الزمنية",
    addNew: "إضافة جدول زمني جديد",
    editTitle: "تعديل الجدول الزمني",
    startTime: "وقت البدء",
    busType: "نوع الحافلة",
    arrival: "الوصول",
    departure: "المغادرة",
    price: "السعر",
    priceAfterDiscount: "السعر بعد الخصم",
    baseFair: "السعر",
    status: "الحالة",
    days: "الأيام",
    saturday: "السبت",
    sunday: "الأحد",
    monday: "الاثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    noSchedules: "لا توجد جداول زمنية للطريق {name}",
    addSuccess: "تمت إضافة الجدول الزمني بنجاح",
    editSuccess: "تم تعديل الجدول الزمني بنجاح",
    deleteSuccess: "تم حذف الجدول الزمني بنجاح",
    confirmDelete: "هل أنت متأكد من حذف هذا الجدول الزمني؟",
    active: "نشط",
    inactive: "غير نشط",
    schedules: "الجداول الزمنية",
    selectCorporate: "اختر الشركة",
    actions: "الإجراءات",
    deleteAllScheduledRun: "حذف جميع الرحلات المجدولة",
    runAll: "تشغيل الكل",
    routeName: "اسم الطريق",
    runsPerWeek: "الرحلات في الأسبوع",
    upComingRuns: "الرحلات القادمة",
    lastRun: "آخر رحلة",
    addSchedule: "إضافة جدول زمني",
    deleteScheduledRun: "حذف الرحلة المجدولة",
    runSchedule: "تشغيل الجدول الزمني",
    viewSchedule: "عرض الجدول الزمني",
    scheduleForRoute: "الجدول الزمني للطريق",
    atTime: "في الوقت",
    run: "تشغيل",
    fetchError: "فشل في جلب الجداول الزمنية",
    whenRunSchedule: "متى تريد تشغيل الجدول الزمني؟",
    now: "الآن",
    atNight: "في الليل",
    confirmDeleteScheduledRun: "هل أنت متأكد من حذف هذه الرحلة المجدولة؟",
    deleteError: "فشل في حذف الرحلة المجدولة",
    runError: "فشل في تشغيل الجدول الزمني",
    forScheduleAt: "للجدول الزمني في",
    ofRoute: "للطريق",
    confirmDeleteAllScheduledRun:
      "هل أنت متأكد من حذف جميع الرحلات المجدولة المحددة؟",
    runScheduleError: "فشل في تشغيل الجدول الزمني",
  },

  // الجداول الزمنية (جمع)
  schedules: {
    title: "الجداول الزمنية",
    addNew: "إضافة جدول زمني جديد",
    editTitle: "تعديل الجدول الزمني",
    startTime: "وقت البدء",
    busType: "نوع الحافلة",
    arrival: "الوصول",
    departure: "المغادرة",
    price: "السعر",
    baseFair: "السعر",
    status: "الحالة",
    days: "الأيام",
    saturday: "السبت",
    sunday: "الأحد",
    monday: "الاثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    noSchedules: "لا توجد جداول زمنية للطريق {name}",
    addSuccess: "تمت إضافة الجدول الزمني بنجاح",
    editSuccess: "تم تعديل الجدول الزمني بنجاح",
    deleteSuccess: "تم حذف الجدول الزمني بنجاح",
    confirmDelete: "هل أنت متأكد من حذف هذا الجدول الزمني؟",
    active: "نشط",
    inactive: "غير نشط",
    schedules: "الجداول الزمنية",
    selectCorporate: "اختر الشركة",
    actions: "الإجراءات",
    deleteAllScheduledRun: "حذف جميع الرحلات المجدولة",
    runAll: "تشغيل الكل",
    routeName: "اسم الطريق",
    runsPerWeek: "الرحلات في الأسبوع",
    upComingRuns: "الرحلات القادمة",
    lastRun: "آخر رحلة",
    addSchedule: "إضافة جدول زمني",
    deleteScheduledRun: "حذف الرحلة المجدولة",
    runSchedule: "تشغيل الجدول الزمني",
    viewSchedule: "عرض الجدول الزمني",
    scheduleForRoute: "الجدول الزمني للطريق",
    atTime: "في الوقت",
    run: "تشغيل",
    fetchError: "فشل في جلب الجداول الزمنية",
    whenRunSchedule: "متى تريد تشغيل الجدول الزمني؟",
    now: "الآن",
    atNight: "في الليل",
    confirmDeleteScheduledRun: "هل أنت متأكد من حذف هذه الرحلة المجدولة؟",
    deleteError: "فشل في حذف الرحلة المجدولة",
    runError: "فشل في تشغيل الجدول الزمني",
    forScheduleAt: "للجدول الزمني في",
    ofRoute: "للطريق",
    confirmDeleteAllScheduledRun:
      "هل أنت متأكد من حذف جميع الرحلات المجدولة المحددة؟",
    runScheduleError: "فشل في تشغيل الجدول الزمني",
  },

  // الطرق


  // الحافلات
  buses: {
    title: "الحافلات",
    addNew: "إضافة حافلة جديدة",
    addTitle: "إضافة حافلة جديدة",
    editTitle: "تعديل الحافلة",
    status: "الحالة",
    plateNumber: "رقم اللوحة",
    busType: "نوع الحافلة",
    busColor: "لون الحافلة",
    busMake: "صنع الحافلة",
    busModel: "موديل الحافلة",
    year: "السنة",
    expireLicenseDate: "تاريخ انتهاء الرخصة",
    active: "نشط",
    model: "الموديل",
    make: "الصنع",
    color: "اللون",
    noBuses: "لا توجد حافلات بعد",
    addSuccess: "تمت إضافة الحافلة بنجاح",
    editSuccess: "تم تعديل الحافلة بنجاح",
    deleteSuccess: "تم حذف الحافلة بنجاح",
    confirmDelete: "هل أنت متأكد من حذف الحافلة؟",
    uploadFiles: "رفع الملفات",
    documents: "المستندات",
    upload: "رفع",
    delete: "حذف",
    imagePreview: "معاينة الصورة",
    confirmDeleteImage: "هل أنت متأكد من حذف الصورة؟",
    uploadSuccess: "تم رفع الملف بنجاح",
    deleteSuccess: "تم حذف الملف بنجاح",
    selectCorporate: "اختر الشركة",
    searchByModel: "البحث بالموديل",
    searchByMake: "البحث بالصنع",
    searchByYear: "البحث بالسنة",
    searchByColor: "البحث باللون",
    searchByBusType: "البحث بنوع الحافلة",
    searchByBus: "اختر الحافلة",
    searchByPlateNumber: "البحث برقم اللوحة",
    searchById: "البحث بالرقم التعريفي",
    activationTitle: "تفعيل الحافلات",
    changeStatus: "تغيير الحالة",
    viewFiles: "عرض الملفات",
    noInactiveBuses: "لا يوجد حافلات غير مفعلة",
    selectStatus: "اختر الحالة",
    selectStatusFirst: "يرجى اختيار الحالة أولاً",
    statusNote: "ملاحظة الحالة",
    statusNotePlaceholder: "أدخل ملاحظة توضح سبب الحالة (اختياري)",
    statusApproved: "مقبول",
    statusRejected: "مرفوض",
    statusPendingData: "يرجى إكمال البيانات",
    statusUnderReview: "تحت المراجعة",
    statusModified: "تم التعديل",
    files: "الملفات",
    noFiles: "لا توجد ملفات متاحة",
    noFilesDescription: "لم يتم رفع أي ملفات لهذه الحافلة بعد",
    noFileUploaded: "لم يتم رفع ملف",
    viewNote: "عرض الملاحظة",
    noNote: "لا توجد ملاحظة",
    searchByNote: "البحث بالملاحظة",
    approvalStatus: "حالة الموافقة",
    activeStatus: "الحالة النشطة",
  },

  // أنواع الحافلات
  busTypes: {
    title: "نوع الحافلة",
    addNew: "إضافة نوع حافلة جديد",
    addTitle: "إضافة نوع حافلة جديد",
    editTitle: "تعديل نوع الحافلة",
    name: "الاسم",
    seats: "المقاعد",
    maxSeats: "الحد الأقصى للمقاعد",
    vehicle: "المركبة",
    active: "نشط",
    noBusTypes: "لا توجد أنواع حافلات بعد",
    addSuccess: "تمت إضافة نوع الحافلة بنجاح",
    editSuccess: "تم تعديل نوع الحافلة بنجاح",
    deleteSuccess: "تم حذف نوع الحافلة بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
    searchByVehicle: "البحث بالمركبة",
    searchBySeats: "البحث بالمقاعد",
    searchByMaxSeats: "البحث بالحد الأقصى للمقاعد",
    manageLayout: "إدارة التخطيط",
    manageFacilities: "إدارة المرافق",
    layoutTitle: "تخطيط الحافلة",
    facilitiesTitle: "مرافق نوع الحافلة",
    regularSeat: "مقعد عادي",
    womanOnly: "للنساء فقط",
    clickToSelect: "انقر لاختيار المقاعد، انقر مرتين للحذف",
    seatSettings: "إعدادات المقعد",
    position: "الموضع",
    chairLabel: "تسمية المقعد",
    chairLabelHelp: "تسمية مخصصة لهذا المقعد",
    womanOnlySeat: "للنساء فقط",
    selectSeatToEdit: "اختر مقعداً لتعديل خصائصه",
    noFacilitiesAssigned: "لا توجد مرافق مخصصة لهذا النوع من الحافلات",
    addNewFacility: "إضافة مرفق جديد",
    selectFacilityToAdd: "اختر مرفقاً لإضافته",
    noMoreFacilities: "لا توجد مرافق أخرى متاحة للإضافة",
    facilityAdded: "تمت إضافة المرفق بنجاح",
    facilityRemoved: "تمت إزالة المرفق بنجاح",
    failedToFetchFacilities: "فشل في جلب المرافق",
    failedToAddFacility: "فشل في إضافة المرفق",
    failedToRemoveFacility: "فشل في إزالة المرفق",
    cannotSelectMoreSeats: "لا يمكنك اختيار أكثر من {maxSeats} مقعد.",
  },

  // الألوان
  colors: {
    title: "الألوان",
    addNew: "إضافة لون جديد",
    addTitle: "إضافة لون جديد",
    editTitle: "تعديل اللون",
    name: "اللون",
    nameAr: "الاسم بالعربية",
    nameEn: "الاسم بالإنجليزية",
    noColors: "لا توجد ألوان بعد",
    addSuccess: "تمت إضافة اللون بنجاح",
    editSuccess: "تم تعديل اللون بنجاح",
    deleteSuccess: "تم حذف اللون بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
  },

  // أسماء المستندات
  docNames: {
    title: "اسم المستند",
    addNew: "إضافة اسم مستند جديد",
    addTitle: "إضافة اسم مستند جديد",
    editTitle: "تعديل اسم المستند",
    name: "اسم المستند",
    busCaptain: "نوع",
    required: "مطلوب",
    noDocNames: "لا توجد أسماء مستندات بعد",
    addSuccess: "تمت إضافة اسم المستند بنجاح",
    editSuccess: "تم تعديل اسم المستند بنجاح",
    deleteSuccess: "تم حذف اسم المستند بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
    captain: "كابتن",
    contractor: "مقاول",
    custom: "مخصص",
    bus: "حافلة",
    employee: "موظف",
  },

  // الصناعات
  makes: {
    title: "الصناعات",
    addNew: "إضافة صناعة جديدة",
    addTitle: "إضافة صناعة جديدة",
    editTitle: "تعديل الصناعة",
    name: "الصناعة",
    nameAr: "الاسم بالعربية",
    nameEn: "الاسم بالإنجليزية",
    noMakes: "لا توجد صناعات بعد",
    addSuccess: "تمت إضافة الصناعة بنجاح",
    editSuccess: "تم تعديل الصناعة بنجاح",
    deleteSuccess: "تم حذف الصناعة بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
  },

  // الموديلات
  models: {
    title: "الموديلات",
    addNew: "إضافة موديل جديد",
    addTitle: "إضافة موديل جديد",
    editTitle: "تعديل الموديل",
    name: "الموديل",
    make: "الصناعة",
    noModels: "لا توجد موديلات بعد",
    addSuccess: "تمت إضافة الموديل بنجاح",
    editSuccess: "تم تعديل الموديل بنجاح",
    deleteSuccess: "تم حذف الموديل بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
  },

  // أنواع المركبات
  vehicleTypes: {
    title: "أنواع المركبات",
    addNew: "إضافة مركبة جديدة",
    addTitle: "إضافة مركبة جديدة",
    editTitle: "تعديل المركبة",
    name: "المركبة بالعربية",
    nameEn: "المركبة بالإنجليزية",
    seats: "المقاعد",
    noVehicleTypes: "لا توجد أنواع مركبات بعد",
    addSuccess: "تمت إضافة نوع المركبة بنجاح",
    editSuccess: "تم تعديل نوع المركبة بنجاح",
    deleteSuccess: "تم حذف نوع المركبة بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
    searchByNameEn: "البحث بالاسم الإنجليزي",
    searchBySeats: "البحث بالمقاعد",
  },

  // السنوات
  years: {
    title: "السنوات",
    addNew: "إضافة سنة جديدة",
    addTitle: "إضافة سنة جديدة",
    editTitle: "تعديل السنة",
    name: "السنة",
    noYears: "لا توجد سنوات بعد",
    addSuccess: "تمت إضافة السنة بنجاح",
    editSuccess: "تم تعديل السنة بنجاح",
    deleteSuccess: "تم حذف السنة بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
  },

  // المرافق
  facilities: {
    title: "المرافق",
    addNew: "إضافة مرفق جديد",
    addTitle: "إضافة مرفق جديد",
    editTitle: "تعديل المرفق",
    nameAr: "اسم المرفق (بالعربية)",
    nameEn: "اسم المرفق (بالإنجليزية)",
    icon: "الأيقونة",
    image: "الصورة",
    noFacilities: "لا توجد مرافق بعد",
    addSuccess: "تمت إضافة المرفق بنجاح",
    editSuccess: "تم تعديل المرفق بنجاح",
    deleteSuccess: "تم حذف المرفق بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
    selectIcon: "اختر أيقونة",
    uploadImage: "رفع صورة المرفق",
    enterAllData: "يرجى إدخال جميع البيانات المطلوبة",
  },

  // أسباب الإلغاء
  cancelReasons: {
    title: "أسباب الإلغاء",
    addNew: "إضافة سبب إلغاء جديد",
    addTitle: "إضافة سبب إلغاء جديد",
    editTitle: "تعديل سبب الإلغاء",
    name: "سبب الإلغاء",
    noCancelReasons: "لا توجد أسباب إلغاء بعد",
    addSuccess: "تمت إضافة سبب الإلغاء بنجاح",
    editSuccess: "تم تعديل سبب الإلغاء بنجاح",
    deleteSuccess: "تم حذف سبب الإلغاء بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
  },

  // فئات الرحلات
  rideCategories: {
    title: "فئات الرحلات",
    addNew: "إضافة فئة رحلة جديدة",
    addTitle: "إضافة فئة رحلة جديدة",
    editTitle: "تعديل فئة الرحلة",
    name: "فئة الرحلة",
    fare: "الأجرة",
    noRideCategories: "لا توجد فئات رحلات بعد",
    addSuccess: "تمت إضافة فئة الرحلة بنجاح",
    editSuccess: "تم تعديل فئة الرحلة بنجاح",
    deleteSuccess: "تم حذف فئة الرحلة بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
    manageFare: "إدارة الأجرة",
    fareTitle: "أجرة فئة الرحلة",
    addFare: "إضافة أجرة",
    editFare: "تعديل الأجرة",
    fareSuccess: "تم حفظ الأجرة بنجاح",
  },

  // الخصومات
  deductions: {
    title: "الخصومات",
    addNew: "إضافة خصم جديد",
    addTitle: "إضافة خصم جديد",
    editTitle: "تعديل الخصم",
    name: "الخصم",
    noDeductions: "لا توجد خصومات بعد",
    addSuccess: "تمت إضافة الخصم بنجاح",
    editSuccess: "تم تعديل الخصم بنجاح",
    deleteSuccess: "تم حذف الخصم بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
  },

  // التعويضات
  compensations: {
    title: "التعويضات",
    addNew: "إضافة تعويض جديد",
    addTitle: "إضافة تعويض جديد",
    editTitle: "تعديل التعويض",
    name: "التعويض",
    noCompensations: "لا توجد تعويضات بعد",
    addSuccess: "تمت إضافة التعويض بنجاح",
    editSuccess: "تم تعديل التعويض بنجاح",
    deleteSuccess: "تم حذف التعويض بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
  },

  // أسباب تغيير الكابتن
  captainChangeReasons: {
    title: "أسباب تغيير الكابتن",
    addNew: "إضافة سبب تغيير كابتن جديد",
    addTitle: "إضافة سبب تغيير كابتن جديد",
    editTitle: "تعديل سبب تغيير الكابتن",
    name: "سبب تغيير الكابتن",
    noCaptainChangeReasons: "لا توجد أسباب تغيير كابتن بعد",
    addSuccess: "تمت إضافة سبب تغيير الكابتن بنجاح",
    editSuccess: "تم تعديل سبب تغيير الكابتن بنجاح",
    deleteSuccess: "تم حذف سبب تغيير الكابتن بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
  },

  // أسباب البداية والنهاية
  startEndReasons: {
    title: "أسباب البداية والنهاية",
    addNew: "إضافة سبب بداية ونهاية جديد",
    addTitle: "إضافة سبب بداية ونهاية جديد",
    editTitle: "تعديل سبب البداية والنهاية",
    name: "سبب البداية والنهاية",
    noStartEndReasons: "لا توجد أسباب بداية ونهاية بعد",
    addSuccess: "تمت إضافة سبب البداية والنهاية بنجاح",
    editSuccess: "تم تعديل سبب البداية والنهاية بنجاح",
    deleteSuccess: "تم حذف سبب البداية والنهاية بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
  },

  // أسباب إلغاء المستخدم
  userCancellationReasons: {
    title: "أسباب إلغاء المستخدم",
    addNew: "إضافة سبب إلغاء مستخدم جديد",
    addTitle: "إضافة سبب إلغاء مستخدم جديد",
    editTitle: "تعديل سبب إلغاء المستخدم",
    name: "سبب إلغاء المستخدم",
    noUserCancellationReasons: "لا توجد أسباب إلغاء مستخدم بعد",
    addSuccess: "تمت إضافة سبب إلغاء المستخدم بنجاح",
    editSuccess: "تم تعديل سبب إلغاء المستخدم بنجاح",
    deleteSuccess: "تم حذف سبب إلغاء المستخدم بنجاح",
    confirmDelete: "هل أنت متأكد من حذف {name}؟",
    selectCorporate: "اختر الشركة",
    searchByName: "البحث بالاسم",
  },

  // الرحلات الحقيقية
  realRides: {
    title: "الرحلات الحقيقية",
    noRides: "لا توجد رحلات حقيقية بعد",
    rideId: "معرف الرحلة",
    rideDate: "تاريخ الرحلة",
    arrivalTime: "وقت الوصول",
    startTime: "وقت البدء",
    fromStop: "من المحطة",
    toStop: "إلى المحطة",
    routeName: "اسم المسار",
    busType: "نوع الحافلة",
    bus: "الحافلة",
    busCaptain: "الحافلة - الكابتن",
    booking: "الحجز",
    status: "الحالة",
    active: "نشط",
    timeLeft: "الوقت المتبقي",
    tripEnded: "انتهى وقت الرحلة",
    invalidDate: "تاريخ غير صحيح",
    rideDetails: "تفاصيل الرحلة",
    todayRides: "رحلات اليوم",
    rides: "الرحلات",
    route: "المسار",
    dateTime: "التاريخ والوقت",
    capacity: "السعة",
    captainName: "اسم الكابتن",
    busPlate: "رقم لوحة الحافلة",
    changeBus: "تغيير الحافلة",
    selectNewBus: "اختر حافلة جديدة",
    cancelRide: "إلغاء الرحلة",
    hideRide: "إخفاء الرحلة الحقيقية",
    showRide: "إظهار الرحلة الحقيقية",
    confirmHide: "هل أنت متأكد من إخفاء هذه الرحلة؟",
    confirmShow: "هل أنت متأكد من إظهار هذه الرحلة؟",
    confirmCancel: "هل أنت متأكد من إلغاء هذه الرحلة؟",
    hideSuccess: "تم إخفاء الرحلة بنجاح",
    showSuccess: "تم إظهار الرحلة بنجاح",
    cancelSuccess: "تم إلغاء الرحلة بنجاح",
    hideFailed: "فشل في إخفاء الرحلة",
    showFailed: "فشل في إظهار الرحلة",
    cancelFailed: "فشل في إلغاء الرحلة",
    changeReason: "سبب التغيير",
    note: "ملاحظة",
    selectReasonNote: "يرجى اختيار سبب وإدخال ملاحظة.",
    captain: "الكابتن",
    contractor: "المقاول",
    name: "الاسم",
    phone: "الهاتف",
    phone2: "الهاتف 2",
    phone3: "الهاتف 3",
    address: "العنوان",
    supply: "التوريد",
    noCaptain: "لا يوجد كابتن بعد",
    searchByDate: "البحث بنطاق التاريخ",
    searchById: "البحث",
    searchByRoute: "البحث",
    searchByBusType: "اختر نوع الحافلة",
    searchByBus: "اختر الحافلة",
    searchByBooking: "البحث",
    statusActive: "نشط",
    statusStarted: "بدأت",
    statusEnded: "انتهت",
    statusHidden: "مخفي",
    statusCancelled: "ملغي",
    selectCorporate: "اختر الشركة",
  },

  // الكباتن
  captains: {
    title: "الكباتن",
    addNew: "إضافة كابتن جديد",
    noCaptains: "لا يوجد كباتن بعد",
    captainName: "اسم الكابتن",
    captainAddress: "عنوان الكابتن",
    personalInfo: "المعلومات الشخصية",
    additionalInfo: "معلومات إضافية",
    contactInfo: "معلومات الاتصال",
    photo: "الصورة",
    nationalID: "الرقم القومي",
    invalidNationalID: "رقم قومي غير صحيح",
    invalidEmail: "بريد إلكتروني غير صحيح",
    gender: "الجنس",
    governate: "المحافظة",
    city: "المدينة",
    religion: "الدين",
    martialStatus: "الحالة الاجتماعية",
    status: "الحالة",
    active: "نشط",
    selectStatus: "اختر الحالة",
    activationTitle: "تفعيل الكباتن",
    activate: "تفعيل",
    noInactiveCaptains: "لا يوجد كباتن غير مفعلين",
    confirmActivate: "هل أنت متأكد من تفعيل هذا الكابتن؟",
    selectCorporate: "اختر الشركة",
    uploadFiles: "رفع ملفات الكابتن",
    busCaptain: "كابتن الحافلة",
    addBanned: "إضافة حظر للكابتن",
    removeBan: "إزالة الحظر",
    noBanned: "لا توجد حظر بعد",
    fromDate: "من تاريخ",
    toDate: "إلى تاريخ",
    banReason: "سبب الحظر",
    allowTime: "وقت السماح",
    bannedUser: "المستخدم المحظور",
    allowUser: "المستخدم المسموح",
    reason: "السبب",
    confirmRemoveBan: "هل أنت متأكد من إزالة الحظر؟",
    addNewBus: "إضافة حافلة جديدة إلى",
    noBusCaptain: "لا يوجد كابتن حافلة بعد",
    bus: "الحافلة",
    confirmRemoveBus:
      "هل أنت متأكد من أخذ الحافلة {busName} من الكابتن {captainName}؟",
    addNewContractor: "إضافة مقاول جديد إلى",
    noContractor: "لا يوجد مقاول بعد",
    contractor: "المقاول",
    confirmRemoveContractor:
      "هل أنت متأكد من أخذ المقاول {contractorName} من الكابتن {captainName}؟",
    uploadSuccess: "تم الرفع بنجاح",
    deleteSuccess: "تم الحذف بنجاح",
    noFiles: "لا توجد ملفات متاحة",
    noFilesDescription: "لم يتم رفع أي ملفات لهذا الكابتن بعد",
    noFileUploaded: "لم يتم رفع ملف",
    confirmDeleteFile: "هل أنت متأكد من حذف هذا الملف؟",
    upload: "رفع",
    delete: "حذف",
    newNote: "ملاحظة جديدة",
    noNotes: "لا توجد ملاحظات كابتن بعد",
    editNote: "تعديل الملاحظة",
    addNewNote: "إضافة ملاحظة جديدة",
    positive: "إيجابي",
    employee: "الموظف",
    time: "الوقت",
    searchById: "البحث بالمعرف",
    searchByName: "البحث بالاسم",
    searchByPlate: "البحث برقم اللوحة",
    searchByNationalID: "البحث بالرقم القومي",
    searchByCity: "البحث بالمدينة",
    searchByAddress: "البحث بالعنوان",
    searchByPhone: "البحث بالهاتف",
    busPlateNumber: "رقم لوحة الحافلة",
    banned: "محظور",
    phone1: "الهاتف 1",
    phone2: "الهاتف 2",
    phone3: "الهاتف 3",
    changeStatus: "تغيير الحالة",
    viewFiles: "عرض الملفات",
    statusApproved: "مقبول",
    statusRejected: "مرفوض",
    statusPendingData: "يرجى إكمال البيانات",
    statusUnderReview: "تحت المراجعة",
    statusModified: "تم التعديل",
    statusNote: "ملاحظة الحالة",
    statusNotePlaceholder: "أدخل ملاحظة توضح سبب الحالة (اختياري)",
    selectStatusFirst: "يرجى اختيار الحالة أولاً",
    viewNote: "عرض الملاحظة",
    noNote: "لا توجد ملاحظة",
    searchByNote: "البحث بالملاحظة",
    approvalStatus: "حالة الموافقة",
    activeStatus: "الحالة النشطة",
    files: "الملفات",
    addSuccess: "تمت الإضافة بنجاح",
    editSuccess: "تم التعديل بنجاح",
    deleteSuccess: "تم الحذف بنجاح",
    enterAllData: "يرجى إدخال جميع البيانات المطلوبة",
    confirmDelete: "هل أنت متأكد من حذف هذا الكابتن؟",
  },

  // تفاصيل الرحلة
  tripDetails: {
    title: "تفاصيل الرحلة",
    trip: "الرحلة",
    captain: "الكابتن",
    bus: "الحافلة",
    route: "الطريق",
    passengers: "الركاب",
    stops: "المحطات",
    captainBalance: "رصيد الكابتن",
    tripStops: "محطات الرحلة",
    tripCaptain: "كابتن الرحلة",
    changeTripDate: "تغيير تاريخ الرحلة",
    cancelTrip: "إلغاء الرحلة",
    startTrip: "بدء الرحلة",
    endTrip: "إنهاء الرحلة",
    changeCaptain: "تغيير الكابتن",
    removeCaptain: "إزالة الكابتن",
    addDeduction: "إضافة خصم",
    addBonus: "إضافة مكافأة",
    hideRealRide: "إخفاء الرحلة الحقيقية",
    showRealRide: "إظهار الرحلة الحقيقية",
    scheduled: "مجدول",
    started: "بدأت",
    ended: "انتهت",
    cancelled: "ملغية",
    notStarted: "لم تبدأ",
    notAssigned: "غير معين",
    at: "في",
    cancel: "إلغاء",
    active: "نشط",
    inactive: "غير نشط",
  },

  // النماذج
  models: {
    title: "الموديلات",
    addNew: "إضافة موديل جديد",
    addTitle: "إضافة نموذج",
    editTitle: "تعديل النموذج",
    name: "اسم النموذج",
    make: "الصنع",
    selectCorporate: "اختر الشركة",
    addSuccess: "تم إضافة النموذج بنجاح",
    editSuccess: "تم تعديل النموذج بنجاح",
  },
  // الموظفين
  employees: {
    title: "الموظفين",
    personalInfo: "البيانات الشخصية",
    contactInfo: "بيانات التواصل",
    addressInfo: "بيانات العنوان",
    workInfo: "بيانات العمل",
    corporateEmployees: "موظفي الشركة",
    addEmployee: "إضافة موظف جديد",
    addNewEmployee: "إضافة موظف جديد",
    editEmployee: "تعديل الموظف",
    employeeName: "اسم الموظف",
    email: "البريد الإلكتروني",
    jobTitle: "المسمى الوظيفي",
    searchOrSelectJobTitle: "ابحث أو اختر المسمى الوظيفي...",
    other: "أخرى...",
    typeNewJobTitle: "اكتب المسمى الوظيفي الجديد أدناه",
    backToList: "العودة إلى القائمة",
    typeNewJobTitlePlaceholder: "اكتب المسمى الوظيفي الجديد...",
    managePages: "إدارة الصفحات",
    confirmDelete: "هل أنت متأكد من حذف الموظف {name}؟",
    confirmResetPassword: "هل أنت متأكد من إعادة تعيين كلمة المرور للموظف {name}؟",
    addedSuccessfully: "تم إضافة الموظف بنجاح",
    updatedSuccessfully: "تم تعديل الموظف بنجاح",
    deletedSuccessfully: "تم حذف الموظف بنجاح",
    passwordResetSuccessfully: "تم إعادة تعيين كلمة المرور بنجاح",
    failedToAdd: "فشل في إضافة الموظف",
    failedToUpdate: "فشل في تعديل الموظف",
    failedToDelete: "فشل في حذف الموظف",
    failedToResetPassword: "فشل في إعادة تعيين كلمة المرور",
    noEmployeesFound: "لا يوجد موظفين",
    noEmployeesFoundMatching: "لا يوجد موظفين مطابقين للمعايير المحددة",
    userID: "رقم المستخدم",
    searchByID: "البحث بالرقم",
    searchByName: "البحث بالاسم",
    searchByEmail: "البحث بالإيميل",
    searchByJobTitle: "البحث بالمسمى الوظيفي",
    assignPagesToUser: "تعيين الصفحات للمستخدم",
    availablePages: "الصفحات المتاحة",
    userPages: "صفحات المستخدم",
    pagesUpdatedSuccessfully: "تم تحديث الصفحات بنجاح",
    failedToUpdatePages: "فشل في تحديث الصفحات",
    addNewEmployees: "إضافة موظفين جدد",
    employeeNameCol: "اسم الموظف",
    nationalID: "الرقم الوطني",
    city: "المدينة",
    address: "العنوان",
    phone1: "الهاتف 1",
    uploadCaptainFiles: "رفع ملفات الكابتن",
    noEmployeesYet: "لا يوجد موظفين بعد",
    confirmation: "تأكيد",
    confirmDeleteEmployees: "هل أنت متأكد من حذف الموظف؟",
    phone2: "الهاتف 2",
    phone3: "الهاتف 3",
    gender: "الجنس",
    governate: "المحافظة",
    religine: "الديانة",
    martialState: "الحالة الاجتماعية",
    group: "المجموعة",
    active: "نشط",
    invalidNationalID: "الرقم الوطني غير صحيح",
    invalidEmail: "البريد الإلكتروني غير صحيح",
    enterAllDataFirst: "يرجى إدخال جميع البيانات أولاً",
    addedSuccessfullyMsg: "تمت الإضافة بنجاح",
    editSuccessMsg: "تم التعديل بنجاح",
    confirmDeleteFile: "هل أنت متأكد من حذف {name}؟",
    fileUploadedSuccessfully: "تم رفع الملف بنجاح",
    fileDeletedSuccessfully: "تم حذف الملف بنجاح",
  },
  // الركاب
  passengers: {
    title: "الركاب",
    customer: "العميل",
    price: "السعر",
    code: "الكود",
    pickupStop: "محطة الاستلام",
    dropOffStop: "محطة النزول",
    seats: "المقاعد",
    status: "الحالة",
    phone: "الهاتف",
    noPassengers: "لا يوجد ركاب بعد",
    checkIn: "تسجيل الدخول",
    checkOut: "تسجيل الخروج",
    missing: "مفقود",
    cancelTrip: "إلغاء الرحلة",
    changeTrip: "تغيير الرحلة",
    addLiveLocation: "إضافة موقع مباشر",
    checkout: "تسجيل الخروج",
    checkoutTitle: "تسجيل الخروج",
    wallet: "المحفظة",
    cash: "نقدي",
    amount: "المبلغ",
    theAmount: "المبلغ",
    tripCost: "تكلفة الرحلة",
    rest: "المتبقي",
    addToWallet: "إضافة إلى المحفظة",
    paid: "تم الدفع",
    cancelReasons: "أسباب الإلغاء",
    cancelReasonsTitle: "أسباب الإلغاء",
    changeReason: "تغيير السبب",
    note: "ملاحظة",
    enterReasonFirst: "الرجاء إدخال السبب أولاً",
    makeCheckIn: "هل أنت متأكد من تسجيل الدخول لـ {name}؟",
    makeCheckOut: "هل أنت متأكد من تسجيل الخروج لـ {name}؟",
    makeMissing: "هل أنت متأكد من تسجيل {name} كمفقود؟",
    enterAmount: "الرجاء إدخال المبلغ",
    userUnavailable: "المستخدم غير متاح",
    editSuccess: "تم التعديل بنجاح",
  },
  time: {
    days: "ي",
    hours: "س",
    minutes: "د",
    seconds: "ث",
  },
  // تسجيل الدخول
  auth: {
    login: "تسجيل الدخول",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    signIn: "تسجيل الدخول",
    signingIn: "جاري تسجيل الدخول...",
    required: "مطلوب",
    loginSuccess: "تم تسجيل الدخول بنجاح",
    loginError: "خطأ في تسجيل الدخول",
    enterEmailPassword: "الرجاء إدخال البريد الإلكتروني وكلمة المرور",
  },
  // إشعارات
  notifications: {
    sendNotificationsToUsers: "إرسال إشعارات للمستخدمين",
    searchForUser: "بحث عن مستخدم...",
    sendNewNotification: "إرسال إشعار جديد",
    notificationTitle: "عنوان الإشعار",
    notificationTitlePlaceholder: "عنوان الإشعار...",
    notificationTitleRequired: "عنوان الإشعار مطلوب",
    messageBody: "نص الرسالة",
    messageBodyPlaceholder: "اكتب نص الرسالة هنا...",
    messageBodyRequired: "نص الرسالة مطلوب",
    send: "إرسال",
    noUserSelected: "لم يتم اختيار مستخدم",
    selectUserToStart: "قم باختيار مستخدم من القائمة الجانبية للبدء في إرسال الإشعارات",
    notificationSent: "تم إرسال الإشعار بنجاح",
    fillAllFields: "الرجاء إدخال جميع البيانات المطلوبة",
  },
  // شروط الاستخدام
  termsOfUse: {
    title: "شروط الاستخدام",
    headerEn: "العنوان (إنجليزي)",
    headerAr: "العنوان (عربي)",
    contentEn: "المحتوى (إنجليزي)",
    contentAr: "المحتوى (عربي)",
    active: "نشط",
    add: "إضافة جديد",
    edit: "تعديل",
  },
};
